import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function geAcChargerReducer (state: RootState): AcChargerState {
  return state.acChargersReducer
}
